"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumbs = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Breadcrumbs = require("./Breadcrumbs.styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Breadcrumbs = function Breadcrumbs(props) {
  var items = props.items;
  var classes = (0, _Breadcrumbs.useStyles)();
  var renderItems = function renderItems() {
    return items.map(function (item, index) {
      var text = item.text,
        url = item.url;
      return /*#__PURE__*/_react["default"].createElement("li", {
        className: classes.item,
        key: index
      }, url ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        className: classes.link,
        to: url
      }, text) : /*#__PURE__*/_react["default"].createElement("span", null, text), index < items.length - 1 && /*#__PURE__*/_react["default"].createElement("span", {
        className: classes.icon
      }, "/"));
    });
  };
  return /*#__PURE__*/_react["default"].createElement("ol", {
    className: classes.root
  }, renderItems());
};
exports.Breadcrumbs = Breadcrumbs;